export type Voice = {
  quote: string
  author: string
  source: string
}

/**
 * VOC real (ficha DPS43): frases textuales de líderes voluntarios en foros
 * públicos, con su fuente. NO son reseñas del producto y la página lo aclara.
 * Cuando haya reseñas reales de compradores, se pueden sumar en otro array.
 */
export const leaderVoices: Voice[] = [
  {
    quote: 'beyond that, I have no ideas.',
    author: 'A pack leader, one day before the meeting',
    source: 'SCOUTER Forum, 2021',
  },
  {
    quote: 'our meetings are BORING.',
    author: 'A troop leader asking for help',
    source: 'SCOUTER Forum, 2022',
  },
  {
    quote: 'It is too much for one person.',
    author: 'A volunteer group leader',
    source: 'Well-Trained Mind Forum',
  },
]

export const moreLeaderVoices: Voice[] = [
  {
    quote: 'I was petrified at first',
    author: 'A brand-new volunteer leader',
    source: 'ScouterMom, 2015',
  },
  {
    quote: 'we’re running out of productive ways to organize our meetings',
    author: 'A leader running 90-minute meetings',
    source: 'SCOUTER Forum, 2012',
  },
  {
    quote: 'even after being a leader for only about 1.5 years, I’m so burned out.',
    author: 'A volunteer group leader',
    source: 'Well-Trained Mind Forum',
  },
]
